import React from 'react';

import { NumeralDisplay } from '../../Fields';
import { NumericalReadOnlyViewProps } from '../types';

export const ExpenseAmountFunnelReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay before={'$'} {...props} />
);
